module.exports = __webpack_public_path__ + "img/hr-green-pita-09.1edac8e5.png";